import genericApi from './genericApi';

import ApiResponse from '../models/ApiResponse';
import AddServicesTariff from '../models/AddServicesTariff';
import FeeParams from '../models/FeeParams';
import FeeTotal from '../models/FeeTotal';

const additionalServicesRequestHandler = {

  getServicesAndTariff: (awbCode: string, awbNumber: string, version: number, isExport?: boolean, poNumber?: string): Promise<ApiResponse<AddServicesTariff>> => {
    let url = `tariff/${awbCode}/${awbNumber}/${version}`;

    if (isExport) {
      url += `?isExport=${isExport}`;
    }
    if (poNumber) {
      url += `?po_number=${poNumber}`;
    }
    return genericApi.get(url);
  },

  getFee: (serviceName: string, awbCode: string, awbNumber: string, version: number, paramsObject: FeeParams, isExport?: boolean): Promise<ApiResponse<FeeTotal>> => {

    let rest = [];
    let url = `fee/${serviceName}/${awbCode}/${awbNumber}/${version}`;
    if (paramsObject.hasOwnProperty('units')) {
      rest.push(`units=${paramsObject.units}`);
    }

    if (paramsObject.hasOwnProperty('kg')) {
      rest.push(`kg=${paramsObject.kg}`);
    }

    if (paramsObject.hasOwnProperty('pickupdate')) {
      rest.push(`pickupdate=${paramsObject.pickupdate}`);
    }

    if (paramsObject.hasOwnProperty('number_hawb')) {
      rest.push(`number_hawb=${paramsObject.number_hawb}`);
    }

    if (paramsObject.hasOwnProperty('transaction_date')) {
      rest.push(`transaction_date=${paramsObject.transaction_date}`);
    }

    if (isExport) {
      rest.push(`isExport=true`);
    }

    const restQuery = rest.length > 0 ? '?' + rest.join('&') : '';
    return genericApi.get(url + restQuery);
  }
};

export default additionalServicesRequestHandler;
